import { graphql, useStaticQuery } from 'gatsby';

import { useMemo } from 'react';

export const useAllProducts = (): Queries.allProductsNodeFragmentFragment[] => {
    const queryResult = useStaticQuery<{
        [key: string]: { nodes: any[] };
    }>(graphql`
        query allProducts {
            allProducts: allProductsJson {
                nodes {
                    ...allProductsNodeFragment
                }
            }
        }
    `);

    return useMemo(() => {
        const { allProducts } = queryResult;
        return allProducts.nodes;
    }, [queryResult]);
};
